module.exports = __webpack_public_path__ + "static/img/数据服务与共享.c9cfebe3.png";